import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-4 fv-row" }
const _hoisted_10 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "within-city" }, "within city", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "with-different-city" }, "with different city", -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6 mt-5" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "required" }
const _hoisted_18 = { class: "col-lg-6 fv-row" }
const _hoisted_19 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "col-md-6 mt-5" }
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "required" }
const _hoisted_27 = { class: "col-lg-6 fv-row" }
const _hoisted_28 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_33 = { class: "mt-5 row" }
const _hoisted_34 = { class: "mt-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "mt-4" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-5" }, "Ride Fare"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-5" }, "Shipment Fare"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-5" }, "Commission")
  ])
], -1)
const _hoisted_36 = { class: "p-5 fw-bold" }
const _hoisted_37 = { class: "p-5" }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = { class: "col-lg-6 fv-row" }
const _hoisted_40 = { class: "p-5" }
const _hoisted_41 = { class: "row mb-6" }
const _hoisted_42 = { class: "col-lg-6 fv-row" }
const _hoisted_43 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_44 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_45 = { class: "indicator-label" }
const _hoisted_46 = { class: "indicator-progress" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('update', 'taxi-meter'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateTaxiMeterRole')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.shpmentSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('taxiMeter')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "areaId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedItem,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItem) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.translate('taxiMeterType')), 1),
                        _hoisted_11,
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.translate('fromCity')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_Field, {
                          as: "select",
                          name: "fromGovernorateId",
                          class: "form-select form-select-solid form-select-lg text-capitalize",
                          modelValue: _ctx.taxi.fromGovernorateId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.taxi.fromGovernorateId) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.translate('selectCity')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.governorates, (governorate) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: governorate.id,
                                value: governorate.id
                              }, _toDisplayString(governorate.title?.find((i) => i.languageCode).title), 9, _hoisted_20))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_ErrorMessage, { name: "fromGovernorateId" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translate('toCity')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_Field, {
                          as: "select",
                          name: "toGovernorateId",
                          class: "form-select form-select-solid form-select-lg text-capitalize",
                          modelValue: _ctx.taxi.toGovernorateId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.taxi.toGovernorateId) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.translate('selectCity')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.governorates, (governorate) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: governorate.id,
                                value: governorate.id
                              }, _toDisplayString(governorate.title?.find((i) => i.languageCode).title), 9, _hoisted_29))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_ErrorMessage, { name: "toGovernorateId" })
                          ])
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, 
                _ctx.selectedItem === 'with-different-city' || _ctx.selectedItem === ''
              ]
                  ]),
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("table", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentSizes, (shipmentSize, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_36, _toDisplayString(shipmentSize.title.find((i) => i.languageCode === 'en')
                          .title), 1),
                            _createElementVNode("td", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createVNode(_component_Field, {
                                    type: "number",
                                    name: 'shipmentData[' + index + '].rideFare',
                                    class: "form-control form-control-lg form-control-solid",
                                    placeholder: _ctx.translate('rideFare'),
                                    onChange: ($event: any) => (
                              shipmentSize.rideFare = $event.target.value
                            ),
                                    modelValue: _ctx.getRideFare(index).value,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.getRideFare(index).value) = $event)
                                  }, null, 8, ["name", "placeholder", "onChange", "modelValue", "onUpdate:modelValue"])
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createVNode(_component_Field, {
                                    type: "number",
                                    name: 'shipmentData[' + index + '].commission',
                                    class: "form-control form-control-lg form-control-solid",
                                    placeholder: _ctx.translate('commission'),
                                    onChange: ($event: any) => (
                              shipmentSize.commission = $event.target.value
                            ),
                                    modelValue: _ctx.getCommission(index).value,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.getCommission(index).value) = $event)
                                  }, null, 8, ["name", "placeholder", "onChange", "modelValue", "onUpdate:modelValue"])
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_44, [
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_46, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_47
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}